// THIS FILE IS USED AS AN EXTENSION TO THE TileLayer LIBRARY OF LEAFLET WHERE WE ADD MORE FUNCTIONLITIES LIKE
// SHOWING FEATURE INFORMATION WHICH GIVES US A VALUE FOR A SPECIFIC POINT WE HAVE SELECTED

import L from 'leaflet';
import $, { param } from 'jquery';
import * as olProj from 'ol/proj';

const TILE_SIZE = 256; // The normal size of a tile layer

function fromLatLngToPoint(latLng) { // We use this function to convert the coordinates from latitude and longitude to points in the map
    var mercator = -Math.log(Math.tan((0.25 + latLng.lat / 360) * Math.PI));
    return {
        x: TILE_SIZE * (latLng.lng / 360 + 0.5),
        y: TILE_SIZE / 2 * (1 + mercator / Math.PI)
    };
}

function fromLatLngToTileCoord(latLng, zoom) { // we use this function to get the i/x and j/y index coordinates 
    var point = fromLatLngToPoint(latLng);// i and j are used for the index location of the point we have clicked in the tileLayer

    return {
        x: Math.floor(point.x * zoom / TILE_SIZE),
        y: Math.floor(point.y * zoom / TILE_SIZE),
        z: zoom
    };
}

const betterWmsLayer = L.TileLayer.WMS.extend({ // extending the tilelayer.wms library

    getValue: function (evt, mapRef) {

        const url = this.getFeatureInfoUrl(evt.latlng);
        
        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                xhrFields: url.includes(process.env.REACT_APP_API_URL) // If we're accessing the backend, we need the credentials (needed for EUMETSAT layers.
                    ? { withCredentials: true }
                    : null,
                success: function (data, status, xhr) {
                    data = JSON.stringify(data);
                    var err = typeof data === 'string' ? null : data;
                    var result = this.getResults(err, data, evt.tsc);
                    resolve(result); // Resolves promise with result
                }.bind(this), // To make 'this' the layer
                error: function (xhr, status, error) {
                    var result = this.getResults(error);
                    resolve(result);
                    //reject(error); // Commented because if there's an error we send at least the date and error message
                }.bind(this) 
            });
        });
        
    },

    getFeatureInfoUrl: function (latlng) {
        // Get the map bounds and dimensions
        var bounds = this._map.getBounds();
        var mapSize = this._map.getSize();
        var mapWidth = mapSize.x;
        var mapHeight = mapSize.y;
    
        // Calculate resolution (per pixel) in map coordinates
        var resolutionX = (bounds.getEast() - bounds.getWest()) / mapWidth;
        var resolutionY = (bounds.getNorth() - bounds.getSouth()) / mapHeight;
        var viewResolution = Math.max(resolutionX, resolutionY); // Use the larger resolution for consistency

        // CRS and coordinates transformation based on the provider
        let transformedCoords, crs, query_layers, layers;

        const provider = this.wmsParams.provider;
        const eumetsatLayers = ["mdfvc", "mdfapar", "frm", "mdmetv3", "metref"];
        let newUrl;
        if(eumetsatLayers.includes(provider)) {

            transformedCoords = {x: latlng.lng, y: latlng.lat}; // EPSG:4326
            crs = 'EPSG:3857';
            query_layers = 'productsInfo';
            layers = 'productsInfo';

        } else {

            transformedCoords = L.CRS.EPSG3857.project(latlng);
            crs = this.wmsParams.crs;
            query_layers = 'products';
            layers = 'products';

        }

        // Calculate bounding box around the transformed coordinates
        var bbox = [
            transformedCoords.x - viewResolution / 2,
            transformedCoords.y - viewResolution / 2,
            transformedCoords.x + viewResolution / 2,
            transformedCoords.y + viewResolution / 2
        ];
    
        // Construct the GetFeatureInfo request parameters
        var params = {
            "request": 'GetFeatureInfo',
            "service": 'WMS',
            "crs": crs,
            "styles": this.wmsParams.styles,
            "transparent": this.wmsParams.transparent,
            "version": this.wmsParams.version,
            "format": this.wmsParams.format,
            "bbox": bbox.join(','), // Join the bounding box array to a string
            "height": this._map.getSize().y, // Height of the map viewport
            "width": this._map.getSize().x,  // Width of the map viewport
            "layers": layers,
            "query_layers": query_layers,
            "info_format": 'application/json',
            "dataType": 'raster',
            "provider": provider,
            "product": this.wmsParams.product,
            "year": this.wmsParams.year,
            "month": this.wmsParams.month,
            "day": this.wmsParams.day,
            "spaceresolution": this.wmsParams.spaceresolution,
            "timeresolution": this.wmsParams.timeresolution,
            "name": this.wmsParams.name,
            "predictionDate": this.wmsParams.predictionDate,
        };
    
        // Get i and j coordinates from latlng and zoom
        let iAndJ = fromLatLngToTileCoord(latlng, this._map.getZoom());
        params[params.version === '1.3.0' ? 'i' : 'x'] = iAndJ.x;
        params[params.version === '1.3.0' ? 'j' : 'y'] = iAndJ.y;
         
        const buildQuery = () => {
            let str = "?";

            Object.entries(params).forEach(([key, value]) => {
                str += key + '=' + value + "&";
            });

            return str;
        }

        // Construct the full URL for the GetFeatureInfo request
        const url = (newUrl ? newUrl : this._url) // If it isn't null (it isn't a EUMETSAT layer), we change the URL request.
            + buildQuery();
 
        return url;
    },    

    getResults: function (err, content, tsc) {
        const layer_config = {
            "mdfapar": {"scale_factor": 0.0001, "nodata": -10},
            "metref": {"scale_factor": 0.01, "nodata": -8000},
            "mdmetv3": {"scale_factor": 0.001, "nodata": -1},
            "mdfvc": {"scale_factor": 0.0001, "nodata": -10}
        }
        const dateString = this.wmsParams.day + '/' + this.wmsParams.month + '/' + this.wmsParams.year;
        const errorStr = 'Point out of extent or no data was returned';

        if (err && !tsc) {
            return [dateString, errorStr];
        }
        if (err) {
            console.error(err);
            return [this.wmsParams.provider, dateString, errorStr];
        }

        let value = JSON.parse(content).Value;

        const layerName = this.wmsParams.provider;
        if (layer_config[layerName]) {
            const config = layer_config[layerName];
            
            // Check if value is not nodata before applying scale
            if (value !== config.nodata) {
                value = value * config.scale_factor;
            }
            // Optional: You might want to handle nodata values differently
            // For example, you could set them to null or keep as is
        }

        if (tsc) { //If the call is from Time Series Chart, we put the layer name too in the array
            return [this.wmsParams.provider, dateString, value];
        } else {
            return [dateString, value]; // For popup display
        }
    }
    /*
    //Not used anymore, functionality for multiple layers implemented here and in mapComponent
    getFeatureInfo: function (evt) { // function that gets the URL of the point and connects to the mapserver to get the value
        var url = this.getFeatureInfoUrl(evt.latlng);// call tpo get the URL
        $.ajax({//ajax request to the mapservr to get data
            url: url,//requesting data from url to rexeive point value
            success: function (data, status, xhr) {// when we connect and get the data we change the type to string and we call the showResults function which presents the data in a popup
                data = JSON.stringify(data);
                var err = typeof data === 'string' ? null : data;
                this.showGetFeatureInfo(err, evt.latlng, data);
            },
            error: function (xhr, status, error) {
                this.showGetFeatureInfo(error);  // if we fail to connect or recieve data we call showResults to show the error we get
            }
        });
    
    },
    showGetFeatureInfo: function (err, latlng, content) { // Used to show the information about point in a popup on the map
        if (err) {
            console.error(err);
            return;
        }

        // Create or update a global variable to store popup content
        if (!window.globalPopupContent) {
            window.globalPopupContent = '';
        }

        const value = JSON.parse(content).Value;

        // We formulate the content of the popup to have the provider date value and coordinates in it
        window.globalPopupContent = `                                                                     
            <b>Provider:</b> ${this.wmsParams.provider}<br>
            <b>Date:</b> ${this.wmsParams.year}/${this.wmsParams.month}/${this.wmsParams.day} <br>
            <b>Value:</b> ${value}<br>
            <b>Latitude: </b>${latlng.lat} | <b>Longitude: </b>${latlng.lng}<br><br>
        `;
        

        // Create a Leaflet popup with the accumulated content which is displayed on the map
        L.popup({ maxWidth: 800 })
            .setLatLng(latlng)
            .setContent(window.globalPopupContent)
            .openOn(this._map);

        
    }
    */

});

export default betterWmsLayer;